var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.header)?_c('th',{class:[
    _vm.sortIsDisabled ? '' : 'column sortable',
    _vm.pagination.descending ? 'desc' : 'asc',
    _vm.header.value === _vm.pagination.sortBy ? 'active' : ''
  ],style:({ width: _vm.header.width }),attrs:{"id":_vm.header.text}},[_c('v-layout',{style:(_vm.headerStyle),attrs:{"row":"","align-center":""}},[_c('span',{style:([
        _vm.headerLabelStyle,
        {
          'max-width':
            _vm.header.hasFilter
              ? _vm.filterActive
                  ? !_vm.sortIsDisabled
                    ? 'calc(100% - 40px)'
                    : 'calc(100% - 28px)'
                  : !_vm.sortIsDisabled
                    ? 'calc(100% - 28px)'
                    : 'calc(100% - 12px)'
              : _vm.sortIsDisabled
                ? '100%'
                : 'calc(100% - 12px)'
        }
      ]),attrs:{"title":_vm.header.text},on:{"click":function($event){!_vm.sortIsDisabled && _vm.changeSort(_vm.header.value)}}},[_vm._v("\n      "+_vm._s(_vm.header.text)+"\n    ")]),_vm._v(" "),(!_vm.sortIsDisabled)?_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.changeSort(_vm.header.value)}}},[_vm._v("\n      "+_vm._s(_vm.sortIcon)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.header.hasFilter)?_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-icon',_vm._g({staticStyle:{"opacity":"1","transform":"unset"},attrs:{"size":"12"}},on),[_vm._v("\n          more_vert\n        ")])]}}],null,false,1022651967)},[_vm._v(" "),_c('v-card',{staticStyle:{"padding":"2px 10px"}},[_vm._t("default")],2)],1):_vm._e(),_vm._v(" "),(_vm.filterActive)?_c('v-icon',{staticStyle:{"opacity":"1","transform":"unset"},attrs:{"size":"12","color":"accent"}},[_vm._v("\n      filter_alt\n    ")]):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fc246c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/FieldWork/Data/ActivityListTableHeaderCell.vue
// module id = null
// module chunks = 